export const partners = [
  'ALEAC',
  'Honduran American Association',
  'Consulate General of Honduras in Los Angeles',
  'Neighborhood Youth Achievers Foundation',
  'Honduran Comité de Cultura',
];

export const marqueePhrases = [
  'Celebrating Our Heritage',
  'Strengthening Our Community',
  'Creating Opportunity',
  '¡Catracho y con orgullo!',
];

export const navLinks = [
  { label: 'Home', href: '#top' },
  { label: 'About', href: '#about' },
  { label: 'Leadership', href: '#leadership' },
  { label: 'Events', href: '#events' },
  { label: 'Pillars', href: '#pillars' },
  { label: 'Mission', href: '#mission' },
  { label: 'News', href: '#news' },
];
